module.exports = __webpack_public_path__ + "static/banner-bg-2c738a8aceefd6f8796ecc0df270322b.jpg";